module.exports = __webpack_public_path__ + "img/1400_4_SkepticalModalButton.04878f31.png";